import React, { useCallback, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../../../../../base/components/Header';
import {
    useAppDispatch,
    useAppSelector,
    useBrowserBackClickHandler,
    useRoutesWithLang,
} from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { Helmet } from '../../../../components/Helmet';
import { settingsActions } from '../../redux/slice/settingsSlice';
import { MessengerNotificationsToggle } from '../../components/MessengerNotificationsToggle';
import { SettingsRoutes } from '../../routes';

import './styles.scss';

export const Settings = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const {
        app: { referrer },
        workerAppSettings: { currentLogin },
    } = useAppSelector((state) => state);
    const settingsRoutes = useRoutesWithLang<typeof SettingsRoutes>(SettingsRoutes);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });

        dispatch(settingsActions.getCurrentLogin());
    }, []);

    const onBackClick = useCallback(() => {
        if (location.state?.from?.pathname) {
            navigate(location.state?.from?.pathname);
            return;
        }
        if (referrer) {
            window.location.href = referrer;
            return;
        }
    }, [referrer, location]);

    useBrowserBackClickHandler(onBackClick);

    return (
        <>
            <Helmet pageName={__t('Настройки')} />
            <div className='settings-page'>
                <Header title={__t('Настройки')} onBackClick={onBackClick} />
                <div className='settings-page__content'>
                    <div className='settings-page__item'>
                        <div className='settings-page__value-column'>
                            <div className='settings-page__title'>{__t('Телефон')}</div>
                            <div className='settings-page__value'>{currentLogin}</div>
                        </div>
                        <Link
                            to={currentLogin ? settingsRoutes.ChangeLogin : settingsRoutes.CreateLogin}
                            state={{ from: location }}
                            className='settings-page__link'
                        >
                            {currentLogin ? __t('Редактировать') : __t('Создать логин')}
                        </Link>
                    </div>
                    <div className='settings-page__divider'></div>
                    <div className='settings-page__item'>
                        <div className='settings-page__value-column'>
                            <div className='settings-page__title'>{__t('Пароль')}</div>
                        </div>

                        <Link
                            to={currentLogin ? settingsRoutes.ChangePassword : settingsRoutes.CreateLogin}
                            state={{ from: location }}
                            className='settings-page__link'
                        >
                            {currentLogin ? __t('Редактировать') : __t('Создать пароль')}
                        </Link>
                    </div>

                    <MessengerNotificationsToggle />
                </div>
            </div>
        </>
    );
};
